import { isEqual } from 'lodash';
import { useRef } from 'react';

export function useStableValue<T>(value: T): T {
  const ref = useRef(value);

  // eslint-disable-next-line react-hooks/refs
  if (!isEqual(value, ref.current)) {
    // eslint-disable-next-line react-hooks/refs
    ref.current = value;
  }

  // eslint-disable-next-line react-hooks/refs
  return ref.current;
}
